import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  CircularProgress,
  PaginationItem,
  Pagination,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import { api, get } from "../../utils/api";
import FilterModal from "../../Components/Common/FilterModal";
import AddIcon from "@mui/icons-material/Add";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import totalticket from "../../assets/images/totalticket.svg";
import resolvedticket from "../../assets/images/resolvedticket.svg";
import pendingticket from "../../assets/images/pendingticket.svg";
import closedticket from "../../assets/images/closedticket.svg";
import styles from "../../styles/support/ticket.module.css";
import { useUser } from "../../context/AuthContext";
import MenuIcon from "../../Components/Masters/MenuIcon";
// import MenuActions from "../../Components/Masters/MenuActions";
import MenuActions from "./MenuActions";
import DeleteDialog from "../../Components/Masters/DeleteDialog";
import AddData from "./AddData";
import ViewDetails from "./ViewDetails";
import dayjs from "dayjs";
import PaginationBox from "../../Components/Masters/Pagination";
import NoDataFound from "../../Components/Masters/NoDataFound";
import { getFacilityName } from "../../utils/facilityColumn";

const CardsList = ({ data }) => {
  return (
    <div className={styles.cardContainer}>
      <img src={data?.icon} alt="icon" />
      <div className={styles.cardsheader}>
        <p className={styles.cardstitle}>{data?.title ?? "-"}</p>
        <p className={styles.cardsvalue}>{data?.value ?? 0}</p>
      </div>
    </div>
  );
};

const ProductionRevenue = () => {
  const tableContainerRef = useRef(null);
  const { user } = useUser();
  const [activeTab, setActiveTab] = useState(0);
  const [otherData, setOtherData] = useState([]);
  const [MYTicketData, setMyTicketData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [endDate, setEndDate] = useState(null);
  const [resolveDrawerOpen, setResolveDrawerOpen] = useState(false);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterEscalation, setEscalation] = useState([]);
  const [filterStatus, setStatus] = useState([]);
  const [cardData, setCardData] = useState({});
  // const [ViewData, setViewData] = useState({});
  const [selectedFields, setSelectedFields] = useState({
    status: [],
    escalationLevel: [],
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState(false);
  const [selectData, setSelectedData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [filterUnits, setUnits] = useState([]);
  const [productionData, setProductionData] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [isShortContent, setIsShortContent] = useState(false);
  const [data, setData] = useState([]);
  const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
  console.log("nedd to know", user);
  useEffect(() => {
    // Check if any filters are actually applied
    const filtersActive = Object.keys(filterObj).length > 0;
    setHasAppliedFilters(filtersActive);
  }, [filterObj]);

  useEffect(() => {
    if (!user?.companyAdmin) {
      setActiveTab(0);
    }
  }, [user]);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    ...(activeTab === 0
      ? [
          {
            title: "Production Quantity",
            type: "limit",
            key: "productionQuantity",
            placeholderMin: "Min Quantity",
            placeholderMax: "Max Quantity",
          },
          {
            title: "Unit",
            type: "option",
            key: "unit",
            value: ["Tons", "Litres", "MWh", "Pieces", "Other"],
          },
          {
            title: "Production Month",
            type: "month",
            key: "productionDate",
          },
        ]
      : []),
    ...(activeTab === 1
      ? [
          {
            title: "Annual Revenue",
            type: "limit",
            key: "annualRevenue",
            placeholderMin: "Min Revenue",
            placeholderMax: "Max Revenue",
          },
          {
            title: "Currency",
            type: "option",
            key: "currency",
            value: ["USD", "INR", "EUR"],
          },
          {
            title: "Revenue Year",
            type: "year",
            key: "revenueDate",
          },
        ]
      : []),
  ].filter(Boolean);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async (filters = filterObj) => {
    setIsLoading(true);
    const filter = { ...filters };

    try {
      const type = activeTab === 0 ? "Production" : "Revenue";
      const params = {
        page: page,
        limit: 10,
        type: type,
        // Extract date filters
        ...(filter.createdAt?.start && { startDate: filter.createdAt.start }),
        ...(filter.createdAt?.end && { endDate: filter.createdAt.end }),
        // Extract unit/currency based on active tab
        ...(activeTab === 0 && filter.unit && { unit: filter.unit.join(",") }),
        ...(activeTab === 1 &&
          filter.currency && { currency: filter.currency.join(",") }),
        // Extract status
        ...(filter.status && { status: filter.status.join(",") }),
      };

      // Add Production Quantity range
      if (activeTab === 0) {
        if (filter.productionQuantity?.min !== undefined) {
          params.minQuantity = filter.productionQuantity.min;
        }
        if (filter.productionQuantity?.max !== undefined) {
          params.maxQuantity = filter.productionQuantity.max;
        }
        //nes
        if (filter.productionDate?.start) {
          params.startMonth = dayjs(filter.productionDate.start).format(
            "YYYY-MM",
          );
        }
        if (filter.productionDate?.end) {
          params.endMonth = dayjs(filter.productionDate.end).format("YYYY-MM");
        }
      }
      // Add Annual Revenue range
      else {
        if (filter.annualRevenue?.min !== undefined) {
          params.minRevenue = filter.annualRevenue.min;
        }
        if (filter.annualRevenue?.max !== undefined) {
          params.maxRevenue = filter.annualRevenue.max;
        }
        if (filter.revenueDate) {
          params.years = filter.revenueDate;
        }
      }

      const queryParams = new URLSearchParams(params).toString();
      const response = await get(`/api/revenue/get?${queryParams}`);
      setData(response.data.data);
      // Update state based on active tab
      activeTab === 0
        ? setOtherData(response.data.data || [])
        : setMyTicketData(response.data.data || []);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      console.log("insit", tableHeight > screenHeight);
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [page, filterObj, activeTab]);

  const filtersToApply = {
    startDate: startDate ? startDate.format("YYYY-MM-DD") : "",
    endDate: endDate ? endDate.format("YYYY-MM-DD") : "",
    ...Object.keys(selectedFields).reduce((acc, key) => {
      const selectedOptions = selectedFields[key];

      // Check if there are selected options
      if (selectedOptions && selectedOptions.length > 0) {
        // Join options into a string or keep them as an array
        acc[key] = selectedOptions.join(","); // Change to an array if needed
      }
      return acc;
    }, {}),
  };

  const handleFilterChange = (newFilterObj) => {
    setPage(1);
    setFilterObj(newFilterObj);
    console.log("Applied Filters:", newFilterObj);
  };

  const handleTabChange = (index) => {
    if (!user?.companyAdmin) return; // Prevent tab change for non-admins
    setActiveTab(index);
    setPage(1);
  };

  const handleAdd = (i) => {
    setIsDrawerOpen(true);
    setIndex(i);
  };

  // Fetch data whenever activeTab changes
  useEffect(() => {
    const type = activeTab === 0 ? "Production" : "Revenue";
    fetchData(type);
  }, [activeTab]);

  const tableData = activeTab === 0 ? otherData : MYTicketData;

  const tabStyles = (isActive) => ({
    borderRadius: "6px",
    textTransform: "none",
    backgroundColor: isActive ? "#1C486B" : "transparent",
    color: isActive ? "white" : "#1C486B",
    borderColor: "#1C486B",
    "&:hover": {
      backgroundColor: isActive ? "#1C486B" : "rgba(24, 77, 128, 0.1)",
      borderColor: "#1C486B",
    },
  });

  const inputData = [
    {
      fieldName: "dataType",
      title: "Data Entered",
      type: "select",
      option: ["Production", "Revenue"],
    },
    {
      fieldName: "periodType",
      title: "Data Period Type",
      placeholder: "Autofilled",
      type: "select",
      option: ["Monthly", "Annual"],
    },

    // {
    //   fieldName: "type",
    //   title: "Type",
    //   placeholder: "select",
    //   type: "select",
    //   option: ["Consolidated", "Facility"],
    // },
    ...(user?.companyAdmin && activeTab === 0
      ? [
          {
            fieldName: "type",
            title: "Type",
            type: "select",
            option: ["Consolidated", "Facility"],
          },
        ]
      : []),

    // {
    //   fieldName: "facilityName",
    //   title: "Facility Name",
    //   // placeholder: "Autofilled",
    //   url: "/master/getAllFacility",
    //   type: "select",
    //   // option: ["Monthly", "Annual"],
    // },
    ...(user?.companyAdmin
      ? [
          {
            fieldName: "facilityName",
            title: "Facility Name",
            url: "/master/getAllFacility",
            type: "select",
          },
        ]
      : []),

    {
      fieldName: "date",
      title: "Month of Production/Year of Revenue",
      placeholder: "Jan-25",
      type: "date",
    },

    {
      fieldName: "production",
      title: "Production Quantity",
      placeholder: "Quantity",
      type: "production",
      required: true,
      // adornmentText: "MT",
      options: ["Tons", "Litres", "MWh", "Pieces", "Other"],
    },

    {
      fieldName: "revenue",
      title: "Annual Revenue",
      placeholder: "Quantity",
      type: "revenue",
      required: true,
      // adornmentText: "MT",
      options: ["USD", "INR", "EUR"],
    },

    {
      fieldName: "remarks",
      title: "Remark",
      placeholder: "Brief",
      type: "multiline",
    },
  ].filter(Boolean);

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
  };

  const handleEdit = (data) => {
    handleMenuClose();
    setViewData(false);
    setIsEditMode(true);
    setIsDrawerOpen(true);
    setSelectedData(data); // Use the passed data
  };

  const handleView = (data) => {
    handleMenuClose();
    setViewData(data); // Set the data to view
    setIsViewOpen(true); // Open the view drawer
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedData(null);
  };

  useEffect(() => {
    console.log("Selected Data for Editing:", selectData);
  }, [selectData]);

  useEffect(() => {
    console.log("Drawer State - Open:", isDrawerOpen, "Edit Mode:", isEditMode);
  }, [isDrawerOpen, isEditMode]);

  const showFacilityColumn = Boolean(user?.companyAdmin);
  const columnWidths =
    activeTab === 0
      ? showFacilityColumn
        ? ["12%", "15%", "13%", "15%", "16%", "15%", "14%"]
        : ["15%", "20%", "16%", "22%", "17%", "10%"]
      : ["22%", "24%", "22%", "22%", "10%"];
  const reportLabel = activeTab === 0 ? "Production Report" : "Revenue";

  const multilineHeader = (key, ...lines) => ({ key, lines });

  const tableHeaders = [
    "Date of Entry",
    activeTab === 0
      ? multilineHeader("monthOfProduction", "Month of", "Production")
      : "Annual",
    activeTab === 0
      ? multilineHeader("productionType", "Production", "Type")
      : null,
    activeTab === 0 && showFacilityColumn
      ? multilineHeader("facilityName", "Facility", "Name")
      : null,
    activeTab === 0
      ? multilineHeader("productionQuantity", "Production", "Quantity")
      : "Annual Revenue",
    activeTab === 0
      ? multilineHeader("productionUnit", "Production", "Unit")
      : "Currency",
    "Action",
  ].filter(Boolean);

  const formatDateBasedOnType = (dateStr, dataType) => {
    if (!dateStr || !dataType) return "-";

    if (dataType === "Production") {
      // Format: MM-YYYY => April-25
      const [monthStr, yearStr] = dateStr.split("-");
      const month = parseInt(monthStr, 10);
      const formattedDate = dayjs(`${yearStr}-${month}-01`).format("MMMM-YY"); // e.g., April-25
      return formattedDate;
    }

    if (dataType === "Revenue") {
      // Format: YYYY-YY => FY 2023-24
      return `FY ${dateStr}`;
    }

    return dateStr;
  };

  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized
        requiredModule={user?.endUser ? "Production" : "Production & Revenue"}
      >
        <>
          <AddData
            inputData={inputData}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            setsnackOpen={setsnackOpen}
            fetchData={() =>
              fetchData(activeTab === 0 ? "Production" : "Revenue")
            }
            editData={selectData}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            user={user}
            activeTab={activeTab}
          />
          <ViewDetails
            setIsViewOpen={setIsViewOpen}
            isViewOpen={isViewOpen}
            selectedData={viewData}
            setView={setViewData}
            handleEdit={handleEdit}
            activeTab={activeTab}
          />
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={filterData}
            onFilterChange={(newFilters) => {
              handleFilterChange(newFilters);
              // This will automatically update via the useEffect
            }}
            title="Filter"
          />

          {deleteDialog && (
            <DeleteDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                id: selectData._id,
                url: `${api}/api/revenue/delete`,
                setsnackOpen,
                fetchData: () =>
                  fetchData(activeTab === 0 ? "Production" : "Revenue"),
                fetchCardData: () => {},
              }}
            />
          )}
          <Snackbar
            open={snackOpen.open}
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setsnackOpen({ ...snackOpen, open: false })}
          >
            <Alert
              severity={snackOpen.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {snackOpen.message}
            </Alert>
          </Snackbar>

          <Box sx={{ paddingTop: "3rem", width: "100%" }}>
            <Box
              sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "fit-content",
                  gap: "16px",
                  minWidth: "180px",
                }}
              >
                {user?.companyAdmin &&
                  ["Production", "Revenue"].map((label, index) => (
                    <Button
                      key={label}
                      onClick={() => handleTabChange(index)}
                      variant={activeTab === index ? "contained" : "outlined"}
                      sx={tabStyles(activeTab === index)}
                    >
                      {label}
                    </Button>
                  ))}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "fit-content",
                  gap: "16px",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => setIsFilterModalOpen(true)}
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "black",
                    "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
                    "&:hover .dot-icon": {
                      color: "#FFFFFF",
                    },
                  }}
                >
                  Filter
                  <FilterListIcon />
                  {hasAppliedFilters && (
                    <FiberManualRecordIcon
                      className="filter-dot"
                      sx={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#488257",
                        marginLeft: "5px",
                        fontFamily: "Inter",
                        textTransform: "none",
                      }}
                    />
                  )}
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#1c486b",
                    fontSize: "14px",
                    textTransform: "none",
                  }}
                  endIcon={<AddIcon />}
                  onClick={() => handleAdd(0)}
                >
                  Add Data
                </Button>
              </Box>
            </Box>

            {isLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
                <CircularProgress />
              </Box>
            ) : (
              <TableContainer
                component={Paper}
                ref={tableContainerRef}
                sx={{
                  maxWidth: "100%",
                  width: "100%",
                  overflowX: "hidden",
                }}
              >
                <Table
                  sx={{
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                    width: "100%",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        colSpan={
                          activeTab === 0
                            ? showFacilityColumn
                              ? 7
                              : 6
                            : 5
                        }
                        sx={{
                          borderBottom: "1px solid #E0E0E0",
                          padding: "20px",
                          fontSize: "20px",
                          fontFamily: "Inter",
                          fontWeight: "600",
                          color: "rgba(34, 34, 34, 1)",
                        }}
                      >
                        {/* Production Report */}
                        {reportLabel}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      {tableHeaders.map((header, idx) => {
                        const isMultiline =
                          typeof header === "object" &&
                          Array.isArray(header?.lines);
                        const headerKey = isMultiline ? header.key : header;
                        return (
                          <TableCell
                            key={headerKey}
                            align="left"
                            sx={{
                              padding: "12px",
                              borderRight: "1px solid #E0E0E0",
                              borderBottom: "1px solid #E0E0E0",
                              fontWeight: "600",
                              width: columnWidths[idx],
                              whiteSpace: "normal",
                              wordBreak: "normal",
                              overflowWrap: "normal",
                              lineHeight: 1.25,
                              fontFamily: "Inter",
                              fontSize: "16px",
                              color: "rgba(34, 34, 34, 1)",
                              verticalAlign: "middle",
                              overflow: "visible",
                            }}
                          >
                            {isMultiline ? (
                              <Box
                                component="span"
                                sx={{
                                  display: "block",
                                  lineHeight: 1.25,
                                }}
                              >
                                {header.lines.map((line, lineIdx) => (
                                  <React.Fragment key={`${headerKey}-${line}`}>
                                    {lineIdx > 0 ? <br /> : null}
                                    {line}
                                  </React.Fragment>
                                ))}
                              </Box>
                            ) : (
                              header
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={
                            activeTab === 0 ? (showFacilityColumn ? 7 : 6) : 5
                          }
                          align="center"
                        >
                          <NoDataFound />
                        </TableCell>
                      </TableRow>
                    ) : (
                      // <TableBody>

                      tableData.map((row) => (
                        <TableRow
                          key={row._id}
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "rgba(34, 34, 34, 1)",
                            "& td": {
                              borderRight: "1px solid #E0E0E0",
                              verticalAlign: "middle",
                              padding: "0px 12px",
                            },
                            "&:last-child td": { borderBottom: "none" },
                          }}
                        >
                          <TableCell>
                            {new Date(row.createdAt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )}
                          </TableCell>
                          {/* <TableCell>
                          {dayjs(row.date, "M-YYYY").format("MMMM-YY")}
                        </TableCell> */}
                          <TableCell>
                            {formatDateBasedOnType(row.date, row.dataType)}
                          </TableCell>
                          {activeTab === 0 ? (
                            <TableCell>{row?.type || "-"}</TableCell>
                          ) : null}
                          {activeTab === 0 && showFacilityColumn ? (
                            <TableCell
                              title={getFacilityName(row) || "-"}
                              sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: 0,
                              }}
                            >
                              {getFacilityName(row) || "-"}
                            </TableCell>
                          ) : null}
                          <TableCell>
                            {activeTab === 0
                              ? row.production?.quantity
                              : row.revenue?.value}
                          </TableCell>
                          <TableCell>
                            {activeTab === 0
                              ? row.production?.unit
                              : row.revenue?.currency}
                          </TableCell>
                          <TableCell>
                            <MenuIcon {...{ handleMenuClick, field: row }} />
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <MenuActions
              {...{
                // id: element?._id,
                // handleView,
                // handleEdit,
                handleView: () => handleView(selectData),
                handleEdit: () => handleEdit(selectData),
                handleDelete,
                anchorEl,
                handleMenuClose,
              }}
            />
          </Box>

          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{
                totalPages,
                page,
                handleChangePage,
                StyledPaginationItem,
              }}
            />
          )}
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default ProductionRevenue;
